import { Directive, inject } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';
import { StreamPlayFilters, StreamPlayState } from '../types/stream-play-models.type';
import { StreamPlayService } from '../stream-play.service';
import { StreamPlayUtils } from '../utils/stream-play-utils';
import { BaseComponentDirective } from '@streamamg/amg-common';

@Directive()
export class StreamPlayListDirective extends BaseComponentDirective {
  public streamPlayIsLoading: boolean | undefined;
  public streamPlayState: StreamPlayState | undefined;
  protected streamPlayApUrl: string | undefined;
  protected streamPlayPageSize: number | undefined;
  protected streamPlayFilters: StreamPlayFilters | undefined;
  protected streamPlayFiltersBody: StreamPlayFilters | undefined;
  protected streamPlayNoCache: boolean | undefined;
  protected streamPlayService = inject(StreamPlayService);

  constructor() {

    super();
  }

  public getStreamPlayItems(isLoadMore?: boolean): Observable<boolean> {
    this.streamPlayIsLoading = true;
    this.cdr.detectChanges();

    const replaySubject = new ReplaySubject<boolean>(1);

    this.subSink = this.streamPlayService
      .triggerApiCall(
        this.streamPlayApUrl,
        this.streamPlayPageSize,
        isLoadMore ? this.streamPlayState: null,
        this.streamPlayFilters,
        true,
        this.streamPlayFiltersBody,
        this.streamPlayNoCache)
      .subscribe((data) => {

        this.streamPlayState = data;
        this.streamPlayIsLoading = false;
        this.cdr.markForCheck();

        replaySubject.next(true);
        replaySubject.complete();
      });

    return replaySubject.asObservable();
  }

  public isMoreDataAvailable(): boolean {

    return <boolean>(this.streamPlayState?.paginationData && StreamPlayUtils.isMoreDataAvailable(this.streamPlayState?.paginationData));
  }
}
